export const userKeys = {
  all: ["user"] as const,
  orders: (address: string) => [...userKeys.all, "orders", address] as const,
  positions: (address: string) =>
    [...userKeys.all, "positions", address] as const,
  pnlHistory: (address: string) =>
    [...userKeys.all, "pnlHistory", address] as const,
};

export const positionKeys = {
  all: ["positions"] as const,
};

export const eventKeys = {
  all: ["events"] as const,
};

export const maintenanceKeys = {
  all: ["maintenance"] as const,
  status: () => [...maintenanceKeys.all, "status"] as const,
};

export const chartMetaKeys = {
  occurences: (marketIndex: number | undefined) =>
    ["markets-occurences-from", marketIndex] as const,
  userTrades: () => ["markets-trades-from-active"] as const,
  userTradesIdx: (
    marketIndex: number | undefined,
    onlyLoggedInUser: boolean,
    publicKeys: string[],
  ) =>
    [
      "markets-trades-for-user-and-market",
      marketIndex,
      onlyLoggedInUser,
      publicKeys,
    ] as const,
};

export const contentKeys = {
  all: ["content"] as const,
  howItWorks: () => [...contentKeys.all, "how-it-works"] as const,
  ctaBoxes: () => [...contentKeys.all, "cta-boxes"] as const,
  mainCTA: () => [...contentKeys.all, "main-cta"] as const,
  comms: () => [...contentKeys.all, "comms"] as const,
};

export const vaultKeys = {
  all: ["vault"] as const,
  vault: (vaultAddress: string) =>
    [...vaultKeys.all, "data", vaultAddress] as const,
  equity: (vaultAddress: string) =>
    [...vaultKeys.all, "equity", vaultAddress] as const,
  depositor: (depositorAddress: string) =>
    [...vaultKeys.all, "depositor", depositorAddress] as const,
  depositorEquity: (depositorAddress: string, vaultAddress: string) =>
    [
      ...vaultKeys.all,
      "depositor-equity",
      depositorAddress,
      vaultAddress,
    ] as const,
};
